import { schema } from 'normalizr';
import merge from 'lodash/merge';
import { LocalizableString } from '../common/types';
import { mapLocalizable } from '../common/utils';

export const boothTierEntity = new schema.Entity('boothTiers', {}, {
  mergeStrategy(first, second) {
    return merge(first, mapLocalizable(second));
  },
  processStrategy(entity) {
    return mapLocalizable(entity);
  },
});

export interface BoothTier {
  id: string;
  name: LocalizableString;
  nameVisible: boolean;
  scale: {
    dimension: number;
    unit: string;
  };
}
